import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function CostAnalysisPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Cost Analysis</h1>
          <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
            🟡 Demo Mode
          </Badge>
        </div>
        <p className="text-muted-foreground mt-2">
          Track and analyse product costs, cost trends, and cost optimisation opportunities.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Content Coming Soon</CardTitle>
          <CardDescription>
            This page will help you understand cost structures and identify opportunities for cost reduction.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Planned features:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Cost breakdown by component</li>
              <li>Historical cost trends</li>
              <li>Supplier cost comparison</li>
              <li>Cost variance analysis</li>
              <li>Cost optimisation recommendations</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
